import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useMenu } from 'src/contexts/menu-context'
import { LEVELS } from '../constants'
import { AlphabeticalMenu } from './MenuComponents/AlphabeticalMenu'
import { ListMenu } from './MenuComponents/ListMenu/ListMenu'

export const ThirdLevel = () => {
  const { state } = useMenu()
  const { updatedMenu } = useGlobalNavigation()

  return (
    <div className="navigation-panel-step active">
      {typeof state.firstLevelItem?.index === 'number' &&
        typeof state.secondLevelItem?.index === 'number' &&
        updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
          state.secondLevelItem.index
        ]?.nextLevel?.items !== null &&
        (updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
          state.secondLevelItem.index
        ]?.nextLevel?.alphabeticalMenu ? (
          <AlphabeticalMenu
            menu={
              updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
                state.secondLevelItem.index
              ]?.nextLevel!
            }
          />
        ) : (
          <ListMenu
            menu={
              updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
                state.secondLevelItem.index
              ]?.nextLevel!
            }
            type={LEVELS.third_level.toString()}
          />
        ))}
    </div>
  )
}
